import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=d3620b26"
import script from "./FormRegister.vue?vue&type=script&lang=ts"
export * from "./FormRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports